
        var result = require("!!../../../../node_modules/css-loader/index.js!./assigned.component.css");

        if (typeof result === "string") {
            module.exports = result;
        } else {
            module.exports = result.toString();
        }
    


//////////////////
// WEBPACK FOOTER
// ./Client/app/views/tenders/assigned.component.css
// module id = 1231
// module chunks = 0